export function trimEndSlash(url) {
    return url.replace(/\/*$/, "");
}
//# sourceMappingURL=trimEndSlash.js.map